import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  getPanelErrorProps,
  TextTitle,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { getLongHeadlinesCardSummaryDetails } from '@bingads-webui-campaign-react/validated-text-collection';
import { LongHeadlineAssetCollection } from './long-headline-asset-collection';
import TextAssetsImg from '../media/text-assets.svg';

export const LongHeadlineAssetCollectionSection = React.memo((props) => {
  const {
    featureName, enableCopilotRecommendations, longHeadlines, expand, isOptional, setAddNewLongHeadlinesCallback, enableCustomizer, ...rest
  } = props;
  const i18n = useContext(I18nContext);
  const longHeadlinesCardSummaryDetails = useMemo(() => getLongHeadlinesCardSummaryDetails(i18n, longHeadlines), [longHeadlines, i18n]);

  return (
    <ValidatedPanel
      key="long-headlines"
      title={<TextTitle
        titleKey={_TL_('Long headlines')}
        icon={TextAssetsImg}
        iconAltText={i18n.getString(_TL_('Long headlines'))}
        details={longHeadlinesCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'long-headlines',
      }}
      {...rest}
    >
      <LongHeadlineAssetCollection
        isOptional={isOptional}
        showDeleteButton={enableCopilotRecommendations}
        setAddNewLongHeadlinesCallback={setAddNewLongHeadlinesCallback}
        featureName={featureName}
        enableCopilotRecommendations={enableCopilotRecommendations}
        enableCustomizer={enableCustomizer}
        withDeleteIconDisabled
      />
    </ValidatedPanel>
  );
});

LongHeadlineAssetCollectionSection.propTypes = {
  isOptional: PropTypes.bool,
  featureName: PropTypes.string,
  enableCopilotRecommendations: PropTypes.bool,
  longHeadlines: PropTypes.shape({}).isRequired,
  expand: PropTypes.func.isRequired,
  setAddNewLongHeadlinesCallback: PropTypes.func.isRequired,
  enableCustomizer: PropTypes.bool,
  withDeleteIconDisabled: PropTypes.bool,
};

LongHeadlineAssetCollectionSection.defaultProps = {
  isOptional: false,
  featureName: undefined,
  enableCopilotRecommendations: true,
  enableCustomizer: true,
  withDeleteIconDisabled: true,
};
